import { z } from 'zod';
import { jMeetingList } from './meeting';
import { jSocialEventList } from './socialEvent';
import { jUserLittleSchema } from './user';

export const calendarOldEventSchema = z.object({
    idArticle: z.number(),
    title: z.string(),
    start: z.string(),
    end: z.string(),
    url: z.string(),
    textColor: z.string().optional(),
    color: z.string().optional(),
    bgColor: z.string().optional(),
    backgroundColor: z.string().optional(),
    subscribe: z.boolean(),
});
export type CalendarOldEvent = z.infer<typeof calendarOldEventSchema>;

export const ensureIsCalendarOldEvent = (o: unknown): o is CalendarOldEvent => {
    return calendarOldEventSchema.safeParse(o).success;
};

export const calendarEventsExtension = z.object({
    maxdate: z.string().optional(),
    subscribers: jUserLittleSchema.array(),
    subscribersTotal: z.number(),
});

export type CalendarEventsExtension = z.infer<typeof calendarEventsExtension>;
export type CalendarCombinedEventsList =
    | (jMeetingList & CalendarEventsExtension)
    | (jSocialEventList & CalendarEventsExtension);
